(async () => {
  const checkLoginFromCenter = () => {
    // 是否是從 會員中心登入過來的
    const loginFromCenterPop = document.getElementById("login-from-center-pop")
    if (loginFromCenterPop) {
      loginFromCenterPop.show()
    }
  }

  const init = () => {
    checkLoginFromCenter()
  }

  await init()
})(window)
